// «О сервисе»: /about.
//
// Страница про то, зачем сервис нужен и чего он не делает. Второе не менее
// важно первого: планировщик, который не продаёт билеты и не берёт комиссию,
// считает иначе, чем витрина, — и человеку стоит знать это до того, как он
// поверит числу на экране.
import type { ReactElement } from 'react';
import { useI18n } from '../i18n';
import { pageContent } from '../content';
import { DocLayout } from './DocLayout';
import styles from './DocLayout.module.css';

export function AboutPage(): ReactElement {
  const { lang } = useI18n();
  const c = pageContent(lang).about;

  return (
    <DocLayout title={c.title} description={c.description} lead={c.lead}>
      {c.sections.map((section) => (
        <section key={section.h} className={styles.doc}>
          <h2 className={styles.h2}>{section.h}</h2>
          {section.p.map((text) => (
            <p key={text} className={styles.text}>
              {text}
            </p>
          ))}
        </section>
      ))}
    </DocLayout>
  );
}
